import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

/**
 * Gate for the cross-partner Price management admin view. The mesh additionally
 * enforces all-partners-full-access server-side on the underlying IPM RPCs, so
 * holding the permission alone is not sufficient to see data.
 */
export const catalogAdminItemPriceManagementAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.ItemPriceManagementViewAccess,
}
